import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: "#1ab3d9",
        secondary: colors.red.lighten4,
        accent: colors.indigo.base,
      },
      light: {
        primary: "#1ab3d9",
        secondary: colors.red.lighten4,
        accent: colors.indigo.base,
      },
    },
  },
});
